import {
  useJ1AuthFetch,
  ApiKey,
  ApiKeyResponse,
  urls,
} from '@jupiterone/jupiter-web-toolkit';

const useAPIKey = () => {
  const { authFetch } = useJ1AuthFetch();
  async function getApiKeys(): Promise<ApiKeyResponse> {
    const result = await authFetch(urls.apiKeys, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return await result.json();
  }

  async function createApiKey(
    name: string,
    expireInDays: number
  ): Promise<ApiKey> {
    const result = await authFetch(`${urls.apiKeys}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name, expireInDays }),
    });
    return await result.json();
  }

  async function deleteApiKey(apiKeyId: string): Promise<Response> {
    const result = await authFetch(`${urls.apiKeys}/${apiKeyId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return await result.json();
  }
  return {
    getApiKeys,
    createApiKey,
    deleteApiKey,
  };
};

export default useAPIKey;
